import React from 'react';
import { useParams, Link } from 'react-router-dom';
import GuideInscriptionPage from './subpages/GuideInscriptionPage';
import ListeFacultesPage from './subpages/ListeFacultesPage';
import ParcoursUniversitairesPage from './subpages/ParcoursUniversitairesPage';
import BibliothequePage from './subpages/BibliothequePage';
import CommuniquesPage from './subpages/CommuniquesPage';
import CalendrierPage from './subpages/CalendrierPage';
import EvenementsAVenirPage from './subpages/EvenementsAVenirPage';
import GaleriePage from './subpages/GaleriePage';
import EntraidePage from './subpages/EntraidePage';
import LogementPage from './subpages/LogementPage';
import RepertoirePage from './subpages/RepertoirePage';
import ActivitesSportivesPage from './subpages/ActivitesSportivesPage';
import ClubLecturePage from './subpages/ClubLecturePage';
import ClubRobotiquePage from './subpages/ClubRobotiquePage';
import ClubDansePage from './subpages/ClubDansePage';
import FaqPage from './subpages/FaqPage';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import SEO from '../components/common/SEO';
import AnimatedSection from '../components/common/AnimatedSection';

const SUBPAGE_MAP = {
  // Espace études
  'guide-inscription': {
    title: 'Guide d’Inscription Universitie – ACEM Fès',
    description: 'Consultez le guide complet d’inscription universitaire pour les étudiants comoriens à Fès. Procédures, démarches et conseils académiques.',
    canonicalPath: '/etudes/guide-inscription',
    breadcrumbName: 'Guide d’inscription',
    component: GuideInscriptionPage,
  },
  'liste-facultes': {
    title: 'Liste des Facultés & Établissements – ACEM Fès',
    description: 'Découvrez la liste complète des universités, facultés et grandes écoles de la région de Fès accueillant les étudiants comoriens.',
    canonicalPath: '/etudes/liste-facultes',
    breadcrumbName: 'Liste des facultés',
    component: ListeFacultesPage,
  },
  'parcours-universitaires': {
    title: 'Parcours Universitaires & Filières – ACEM Fès',
    description: 'Explorez les diplômes, filières et parcours universitaires disponibles pour les étudiants comoriens à Fès (Licence, Master, Doctorat, Ingénierie).',
    canonicalPath: '/etudes/parcours-universitaires',
    breadcrumbName: 'Parcours universitaires',
    component: ParcoursUniversitairesPage,
  },
  'bibliotheque': {
    title: 'Bibliothèque Digitale & Ressources PDF – ACEM Fès',
    description: 'Accédez à la bibliothèque numérique officielle de Garadet (ACEM Fès). Cours, épreuves, guides et documents administratifs téléchargeables en PDF.',
    canonicalPath: '/etudes/bibliotheque',
    breadcrumbName: 'Bibliothèque digitale',
    component: BibliothequePage,
  },

  // Événements
  'communiques': {
    title: 'Communiqués Officiels & Annonces – ACEM Fès',
    description: 'Retrouvez les communiqués officiels, appels et annonces importantes du bureau exécutif de l’ACEM Fès.',
    canonicalPath: '/evenements/communiques',
    breadcrumbName: 'Communiqués officiels',
    component: CommuniquesPage,
  },
  'calendrier': {
    title: 'Calendrier Annuel des Activités – ACEM Fès',
    description: 'Consultez le calendrier officiel des événements académiques, culturels, religieux et sportifs du mandat ACEM Fès.',
    canonicalPath: '/evenements/calendrier',
    breadcrumbName: 'Calendrier annuel',
    component: CalendrierPage,
  },
  'a-venir': {
    title: 'Événements à Venir & Agenda – ACEM Fès',
    description: 'Découvrez les prochains événements organisés par l’ACEM Fès. Conférences, tournois sportifs et rassemblements communautaires.',
    canonicalPath: '/evenements/a-venir',
    breadcrumbName: 'Événements à venir',
    component: EvenementsAVenirPage,
  },
  'galerie': {
    title: 'Galerie Photos & Souvenirs – ACEM Fès',
    description: 'Parcourez la galerie photo officielle retraçant les moments forts et événements marquants de la communauté comorienne à Fès.',
    canonicalPath: '/evenements/galerie',
    breadcrumbName: 'Galerie photos',
    component: GaleriePage,
  },

  // Espace social
  'entraide': {
    title: 'Démarches Administratives & Solidarité – ACEM Fès',
    description: 'Guide des démarches administratives au Maroc (Carte de séjour, bourse, visa, santé) et services d’entraide pour les comoriens de Fès.',
    canonicalPath: '/social/entraide',
    breadcrumbName: 'Démarches & Solidarité',
    component: EntraidePage,
  },
  'logement': {
    title: 'Nos Partenaires & Logements – ACEM Fès',
    description: 'Partenariats exclusifs et accompagnement au logement étudiant pour les membres de l’ACEM Fès.',
    canonicalPath: '/social/partenaires',
    breadcrumbName: 'Nos Partenaires',
    component: LogementPage,
  },
  'partenaires': {
    title: 'Nos Partenaires – ACEM Fès',
    description: 'Découvrez les entreprises, institutions et partenaires accompagnant l’ACEM Fès et ses étudiants.',
    canonicalPath: '/social/partenaires',
    breadcrumbName: 'Nos Partenaires',
    component: LogementPage,
  },
  'activites-sportives': {
    title: 'Activités Sportives & Compétitions – ACEM Fès',
    description: 'Découvrez les activités sportives, l’équipe de football, les tournois réguliers et le palmarès de l’ACEM Fès.',
    canonicalPath: '/social/activites-sportives',
    breadcrumbName: 'Activités sportives',
    component: ActivitesSportivesPage,
  },
  'sports': {
    title: 'Activités Sportives – ACEM Fès',
    description: 'Découvrez les activités sportives et compétitions de l’ACEM Fès.',
    canonicalPath: '/social/activites-sportives',
    breadcrumbName: 'Activités sportives',
    component: ActivitesSportivesPage,
  },
  'repertoire': {
    title: 'Répertoire Utile & Urgences – ACEM Fès',
    description: 'Numéros utiles, contacts d’urgence, ambassade et adresses essentielles pour les étudiants comoriens à Fès.',
    canonicalPath: '/social/repertoire',
    breadcrumbName: 'Répertoire utile',
    component: RepertoirePage,
  },
  'faq': {
    title: 'Foire Aux Questions (FAQ) – ACEM Fès',
    description: 'Toutes les réponses aux questions fréquemment posées sur les études, les démarches administratives, la carte de séjour et l’ACEM Fès.',
    canonicalPath: '/social/faq',
    breadcrumbName: 'Foire aux questions (FAQ)',
    component: FaqPage,
  },

  // Nos clubs
  'club-lecture': {
    title: 'Club de Lecture & Culture – ACEM Fès',
    description: 'Rejoignez le club de lecture de l’ACEM Fès. Activités littéraires, échanges d’ouvrages et débats culturels.',
    canonicalPath: '/clubs/club-lecture',
    breadcrumbName: 'Club de lecture',
    component: ClubLecturePage,
  },
  'club-robotique': {
    title: 'Club de Robotique & Innovation – ACEM Fès',
    description: 'Projets technologiques, ateliers de programmation et réalisations du club de robotique de l’ACEM Fès.',
    canonicalPath: '/clubs/club-robotique',
    breadcrumbName: 'Club de robotique',
    component: ClubRobotiquePage,
  },
  'club-danse': {
    title: 'Club de Danses Traditionnelles – ACEM Fès',
    description: 'Promotion et préservation du patrimoine culturel comorien à travers les danses traditionnelles.',
    canonicalPath: '/clubs/club-danse',
    breadcrumbName: 'Club de danses traditionnelles',
    component: ClubDansePage,
  },
};

export default function SubPage() {
  const { section, slug } = useParams();
  const pageConfig = SUBPAGE_MAP[slug];

  if (!pageConfig) {
    return (
      <div className="py-16 max-w-lg mx-auto text-center animate-fade-in px-4">
        <SEO
          title="Page Introuvable (404)"
          description="La rubrique demandée n'existe pas ou a été déplacée."
          noindex={true}
        />
        <Card variant="glass" className="p-8 space-y-4">
          <div className="text-4xl">🔍</div>
          <h2 className="font-title text-2xl font-bold text-acem-primary-dark">
            Page Introuvable
          </h2>
          <p className="text-xs sm:text-sm text-acem-muted">
            La rubrique demandée n'existe pas ou a été déplacée.
          </p>
          <div className="pt-2">
            <Button as={Link} to="/" variant="primary" size="md">
              Retour à l'accueil
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  const currentCanonical = pageConfig.canonicalPath || `/${section || 'pages'}/${slug}`;

  const subpageSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `https://acem-fes.com${currentCanonical}#webpage`,
        "url": `https://acem-fes.com${currentCanonical}`,
        "name": pageConfig.title,
        "description": pageConfig.description,
        "inLanguage": "fr-FR",
        "isPartOf": {
          "@type": "WebSite",
          "@id": "https://acem-fes.com/#website",
          "url": "https://acem-fes.com/",
          "name": "ACEM Fès"
        }
      },
      pageConfig.breadcrumbName ? {
        "@type": "BreadcrumbList",
        "@id": `https://acem-fes.com${currentCanonical}#breadcrumb`,
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Accueil",
            "item": "https://acem-fes.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": pageConfig.breadcrumbName,
            "item": `https://acem-fes.com${currentCanonical}`
          }
        ]
      } : null
    ].filter(Boolean)
  };

  const SubComponent = pageConfig.component;
  return (
    <div className="py-4 sm:py-8 max-[984px]:px-4">
      <SEO
        title={pageConfig.title.replace(' – ACEM Fès', '').replace(' - ACEM Fès', '')}
        description={pageConfig.description}
        canonical={currentCanonical}
        jsonLd={subpageSchema}
      />
      <AnimatedSection animation="fade-up" duration={0.6}>
        <SubComponent />
      </AnimatedSection>
    </div>
  );
}

